import React from 'react';
import './VersionWatermark.css';

const VersionWatermark = () => {
  // Version from package.json - update this when version changes
  const version = '1.3.0';

  return (
    <div className="version-watermark">
      v{version}
    </div>
  );
};

export default VersionWatermark;
